import React, { useState, KeyboardEvent } from 'react';
import { TextField, Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  textField: {
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1),
  },
  button: {
    marginLeft: theme.spacing(1),
  },
}));

interface QueryInputProps {
  onSubmit: (query: string) => void;
  isLoading: boolean;
}

export const QueryInput: React.FC<QueryInputProps> = ({
  onSubmit,
  isLoading,
}) => {
  const classes = useStyles();
  const [query, setQuery] = useState('');

  const handleQueryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
  };

  const handleSubmit = () => {
    if (query.trim() !== '') {
      onSubmit(query);
      setQuery('');
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' && !event.shiftKey && query.trim() !== '') {
      event.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className={classes.container}>
      <TextField
        className={classes.textField}
        label="Your query"
        variant="outlined"
        value={query}
        onChange={handleQueryChange}
        onKeyDown={handleKeyDown}
        autoFocus
        multiline
        minRows={3}
        margin="normal"
        disabled={isLoading}
        placeholder="Ask a question or what you want to do..."
      />
      <div className={classes.buttonContainer}>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={query.trim() === '' || isLoading}
          className={classes.button}
        >
          Send
        </Button>
      </div>
    </div>
  );
};
